import type { ConversationTask } from "@/services/api/guardiansv2/types";
import { EntityLink } from "../shared/EntityLink";
import type { ScopeLabelCache } from "../audits/useScopeLabelCache";

export interface TaskConversationDividerProps {
  task: ConversationTask["task"];
  missionId?: string | null;
  scopeLabels: ScopeLabelCache;
}

/** Thin separator with centered, uppercase task link between conversation blocks. */
export function TaskConversationDivider({
  task,
  missionId,
  scopeLabels,
}: TaskConversationDividerProps) {
  return (
    <div
      className="flex items-center gap-3"
      data-testid={`conversation-task-divider-${task.id}`}
    >
      <div className="h-px flex-1 bg-white/10" aria-hidden />
      <EntityLink
        subject={{ type: "task", id: task.id }}
        scope={{ mission_id: missionId, task_id: task.id }}
        scopeLabels={scopeLabels}
        title={task.name}
        className="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-300"
      />
      <div className="h-px flex-1 bg-white/10" aria-hidden />
    </div>
  );
}
